module.exports = __webpack_public_path__ + "/images/screen-vendedores-plantillas.3b3255b.webp";